import '../styles/Cart.css';

import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from "../middleware/TrackCart.jsx";

import CartProduct from '../components/CartProduct.js';

import { client } from '../middleware/ShopifyClient.jsx';

import updateDocumentTitle from '../utils/updateDocumentTitle.js';

export default function Cart() {
    const { cartItems, addItemToCart, removeItemFromCart, isItemInCart } = useContext(CartContext);

    updateDocumentTitle('Cart');

    // Remove this useEffect since we don't need cartOnPrint anymore
    /* useEffect(() => {
        setCartOnPrint([...cartItems]);
    }, [cartItems]); */

    // This allows for product to stay in cart if removed (for readding)
    // Product is removed upon reload as it would not be included in localStorage
    // after the initial removal... unless it was readded to cart..!
    // const [cartOnPrint, setCartOnPrint] = useState(cartItems);

    async function createCheckout(cartItems) {
        const lines = cartItems.map((item) => ({
          merchandiseId: item.variants.edges[0].node.id,
          quantity: item.quantity || 1,
        }));
      
        const cartCreateMutation = `
          mutation ($input: CartInput!) {
            cartCreate(input: $input) {
              cart {
                id
                checkoutUrl
              }
              userErrors {
                message
              }
            }
          }
        `;
      
        try {
          const { data, errors } = await client.request(cartCreateMutation, {
            variables: { input: { lines } },
          });
      
          if (errors) {
            console.error('GraphQL errors:', errors);
          } else {
            const checkoutUrl = data?.cartCreate?.cart?.checkoutUrl;
            if (checkoutUrl) {
              window.location.href = checkoutUrl;  // Redirect to checkout URL
            }
          }
        } catch (err) {
          console.error('Cart creation failed:', err);
        }
    }

    // this below is repeated in Product.jsx
    // Part of a larger pattern of needing to be able 
    // to update cart via ANY product listings.
    const RemoveFromCart = (event, id) => {
        event.stopPropagation();
        removeItemFromCart(id);
        // No need to manually update cartOnPrint here as the useEffect will handle it
    }

    const AddToCart = (event, product) => {
        event.stopPropagation();
        addItemToCart(product);
    }

    return (
        <div className="cart-page">
            <div className="cart-title-section">
                <div className="container">
                    <h2>Your Cart</h2>
                    <p className="subtitle">Review and manage your selected contract templates</p>
                </div>
            </div>
            
            <div className="cart-main">
                {cartItems.length > 0 ? (
                    <div className="cart-container">
                        <div className="cart-items">
                            {cartItems.map((item, key) => (
                                <CartProduct key={item.id} item={item} cart={{ AddToCart, RemoveFromCart, isItemInCart }} />
                            ))}
                        </div>
                        
                        <div className="cart-summary">
                            <h2>Order Summary</h2>
                            <div className="summary-row">
                                <span>Items ({cartItems.length})</span>
                                <span>Calculated at checkout</span>
                            </div>
                            <div className="summary-divider"></div>
                            <div className="checkout-button-container">
                                <button 
                                    className="checkout-button"
                                    onClick={() => createCheckout(cartItems)}
                                >
                                    Proceed to Checkout
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="empty-cart">
                        <div className="empty-cart-message">
                            <img src="/images/icons/empty-cart.svg" alt="Empty cart" className="empty-cart-icon" />
                            <h2>Your cart is empty</h2>
                            <p>Looks like you haven't added any contracts to your cart yet.</p>
                            <Link to="/library" className="shop-now-button">
                                Shop Contracts
                            </Link>
                        </div>
                    </div>
                )}
            </div>
            
            <div className="cart-footer">
                <div className="cart-footer-content">
                    <div className="cart-footer-info">
                        <h3>Secure Checkout</h3>
                        <p>All transactions are secure and encrypted</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
